
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import _ from 'lodash';
import { getModule } from 'vuex-module-decorators';

import {
    store,
    CustomerModule,
    ReturnCarrierServiceModule,
    TradeInModule,
    ShopModule
} from "@returns-centre/store";

import {
    ValidationErrors,
    TradeInReturnCarrierServices
} from '@returns-centre/components';

@Component({
    components: {
        TradeInReturnCarrierServices,
        ValidationErrors,
    }
})
export default class TradeInShipping extends Vue {
    customerModule = getModule(CustomerModule, store);
    tradeInModule = getModule(TradeInModule, store);
    shopModule = getModule(ShopModule, store);
    returnCarrierServiceModule = getModule(ReturnCarrierServiceModule, store);
}
